import { SanityLink } from "@brexhq/shared/types/SanityLink";

export const getBlockWithDefaultMarks = (text: any) =>
  text.map((block: any) => {
    return {
      ...block,
      children: block.children.map((child: any) => {
        return {
          ...child,
          marks: child.marks.length ? child.marks : ["gray"],
        };
      }),
    };
  });

interface LinkFromSanityAllValues {
  link: SanityLink | null;
}

export const buildLinkPath = ({
  link,
}: LinkFromSanityAllValues): string | null | undefined => {
  if (link?.hash) {
    return link.hash.includes("#") ? link.hash : `#${link.hash}`;
  }

  return link?.toExternal ?? link?.to;
};
